import React from "react"
import _ from "lodash"
// Styles
import { Label_s } from 'styles/app-styles'
import { MultipleRow_s } from 'components/table/hovers/hover-styles'

type IHover = {
  data: {}
  namedItems: {}
}

const UsersHover = (props: IHover) => {
  const type = _.get(props, "data.users.type")
  const users = type === "user" ? _.get(props, "namedItems.users") : _.get(props, "namedItems.usergroups")
  const selectedUsers = _.get(props, "data.users.ids")
  let prefix = type === "user" ? "Users" : "User Groups"

  if(selectedUsers.length === 1) {
    let code = ""
    if(type === "user") {
      prefix = "User:"
      code = _.get(_.find(users, (u) => u.userid === selectedUsers[0]), "name")
    } else {
      prefix = "User Group:"
      code = _.get(_.find(users, (u) => u.usergroupid === selectedUsers[0]), "code")
    }
    return <span>{`${prefix} ${code}`}</span>
  } else return (
    <div style={{padding: "5px"}}>
      <MultipleRow_s>
        <table>
          <thead>
            <th>
              <Label_s>{prefix}</Label_s>
            </th>
          </thead>
          { _.chain(selectedUsers).take(3).map((s, i) => {
            let code = ""
            if(type === "user") {
              code = _.get(_.find(users, (u) => u.userid === s), "name")
            } else {
              code = _.get(_.find(users, (u) => u.usergroupid === s), "code")
            }
            return (
              <tr>
                <span>{code}</span>
              </tr>
            )
          }).value() }
        </table>
        { (selectedUsers.length > 3) && <div style={{marginLeft: 'auto', textAlign: 'right'}}><strong>...</strong></div>}
      </MultipleRow_s>
    </div>
  )
}

export default UsersHover
